'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _components = require('components');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TableInput = function TableInput(props) {
  var _TableInput = function _TableInput(_ref) {
    var value = _ref.value,
        onValue = _ref.onValue;

    var parseValue = function parseValue(v) {
      return value === parseFloat(value) ? parseFloat(v) : v;
    };
    var onBlur = function onBlur(_ref2) {
      var value = _ref2.target.value;
      // eslint-disable-line no-shadow
      onValue(parseValue(value));
    };
    var onKeyUp = function onKeyUp(_ref3) {
      var key = _ref3.key,
          value = _ref3.target.value;
      // eslint-disable-line no-shadow
      if (key === 'Enter') {
        onValue(parseValue(value));
      }
    };
    return _react2.default.createElement(_components.EnterpriseInput, (0, _extends3.default)({
      id: 'this-input',
      type: 'text',
      defaultValue: value || null,
      onBlur: onBlur,
      onKeyUp: onKeyUp,
      size: _components.ENTERPRISE_INPUT_SIZES.DEFAULT,
      fill: true
    }, props));
  };

  _TableInput.propTypes = {
    value: _react2.default.PropTypes.any,
    onValue: _react2.default.PropTypes.func
  };

  return _TableInput;
};

exports.default = TableInput;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/enterprise/EnterpriseTable/TableControls/TableInput/TableInput.jsx
// module id = 1613
// module chunks = 0